import { render } from "./ChangeHistory.vue?vue&type=template&id=ebc8ce7a"
import script from "./ChangeHistory.vue?vue&type=script&lang=js"
export * from "./ChangeHistory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\20\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__